import { c as _c } from "react/compiler-runtime";
import { useAuthentication } from "../../hooks/index.js";
import { useAutoSelectWallet } from "../../hooks/useAutoSelectWallet.js";
const AuthenticationProvider = t0 => {
  const $ = _c(3);
  const {
    partnerId,
    automaticallySetFirstEoa,
    defaultEoaProvider
  } = t0;
  useAuthentication(partnerId);
  let t1;
  if ($[0] !== automaticallySetFirstEoa || $[1] !== defaultEoaProvider) {
    t1 = {
      enabled: automaticallySetFirstEoa,
      defaultEoaProvider
    };
    $[0] = automaticallySetFirstEoa;
    $[1] = defaultEoaProvider;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useAutoSelectWallet(t1);
  return null;
};
export default AuthenticationProvider;